export function slugify(text) {
    return text
        .toString() // Convert to string
        .toLowerCase() // Convert to lowercase
        .trim() // Remove whitespace from both ends
        .replace(/[^\p{L}\p{N}]+/gu, '-') // Replace spaces and non-alphanumeric characters (except letters and numbers) with dashes
        .replace(/^-+|-+$/g, ''); // Remove leading and trailing dashes
}
